import { MotorQuotationInterface } from "./../../interface/motor-quotation.interface";
import { VehicleInfoSelectionInterface } from "./../../interface/motor.interface";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class MotorQuotationDataService {
  private basePath: string = `${environment.url}/api/Microsite/`;

  constructor(private http: HttpClient) {}

  submit(request: MotorQuotationInterface) {
    return this.http.post<MotorQuotationResponse>(
      `${this.basePath}Submit`,
      request
    );
  }

  submitRequest(request: MotorQuotationInterface) {
    return this.http.post<MotorQuotationResponse>(
      `${this.basePath}SubmitRequest`,
      request
    );
  }

  submitCustomerInfo(request: SubmitCustomerInfoRequest) {
    return this.http.post(`${this.basePath}InsertCustomerInfo`, request);
  }

  checkEligibilityForComprehensive(id: string) {
    return this.http.get<{isEligible: boolean}>(
      `${this.basePath}CheckEligibilityForComprehensive/${id}`);
  }

  submitExtraProduct(id: string, typeOfSum: string, idList: string[]) {
    return this.http.post(`${this.basePath}SubmitExtraProduct/${id}`, {
      typeOfSum,
      selectedMotorProductIds: idList
    });
  }

  checkDuplicateRequest(request: CheckDuplicateRequest) {
    return this.http.post<CheckDuplicateResponse>(
      `${this.basePath}CheckDuplicateRequest`,
      request
    );
  }

  getVehicleInfoSelectionList() {
    return this.http.get<VehicleInfoSelectionInterface[]>(
      `${this.basePath}GetVehicleInfoSelectionList`
    );
  }

  processVehicleInfo(formData: FormData) {
    return this.http.post(`${this.basePath}ProcessVehicleInfo`, formData);
  }

  processVehicleGrant(formData: FormData) {
    return this.http.post(`${this.basePath}ProcessVehicleGrant`, formData);
  }
}

interface MotorQuotationResponse {
  isSuccess: boolean;
  motorRequestId: string;
  redirect_url: string;
  insuranceType: string;
  isQuotationTooEarly: boolean;
  ncdExpDate: string;
  isVehicleUnderAged: boolean;
  isVehicleOverAged: boolean;
  isEhailing: boolean;
}

export interface CheckDuplicateResponse {
  isExist: "Y" | "N";
  isLinkExist: "Y" | "N";
}

export interface CheckDuplicateRequest {
  vehicleNo: string;
  identityNo: string;
  email: string;
  mobileNo: string;
  postcode: string;
  eHailingUsed: boolean;
  preferredChannel: string;
}

export interface SubmitCustomerInfoRequest {
  vehicleNo: string;
  postcode: string;
  mobileNo: string;
  email: string;
  isMalaysian: boolean;
  isCompany: boolean;
  isCommercialIndividual: boolean;
  isCommercialCompany: boolean;
  name: string;
  identityNo: string;
  policIdentityNo: string;
  dob: Date;
  gender: string;
  nationality: string;
  insuranceType: string;
}
